var MODAL_DATA_TESTIDS = {
  content: "mntl-modal-content"
};

export { MODAL_DATA_TESTIDS };
